
<template>
  <div cy-id="playlist-search">
    <v-row>
      <v-col sm="12">
        <v-text-field
          label="Spotify playlist id"
          v-model="query"
          data-testid="search-playlist-id"
        ></v-text-field>
      </v-col>
    </v-row>
    <BuilderPlaylistTile v-model="query">
      <v-btn color="green" dark slot="button" @click="add" cy-id="add">
        Add playlist
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </BuilderPlaylistTile>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import BuilderPlaylistTile from './BuilderPlaylistTile.vue'

@Component({
  components: {
    BuilderPlaylistTile,
  }
})
export default class BuilderPlaylistSearch extends Vue {
  query = ''

  add () {
    this.$emit('add', this.query)

    this.query = ''
  }
}
</script>

<style scoped></style>
